import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

const BooleanValue = props => {
	const { value, isTrue, isFalse, falsyValues, empty } = props;
	const falsy = [ false, ...falsyValues ];
	return <div className="boolean-value">
		{value === true ? isTrue : falsy.includes(value) ? isFalse : empty}
	</div>;
};

BooleanValue.propTypes = {
	value: PropTypes.oneOf([ null, true, false ]),
	isTrue: PropTypes.any,
	isFalse: PropTypes.any,
	empty: PropTypes.string,
	falsyValues: PropTypes.array,
};

BooleanValue.defaultProps = {
	isTrue: <FontAwesomeIcon icon={faCheck}/>,
	isFalse: <FontAwesomeIcon icon={faTimes}/>,
	empty: '-',
	falsyValues: [],
};

export default BooleanValue;
